import { useState, useEffect } from 'react';
import { getTokenLogoUrl, getTokenColor } from '../../lib/tokenLogos';

interface TokenIconProps {
  symbol: string;
  size?: string;
  className?: string;
}

export function TokenIcon({ symbol, size = 'w-8 h-8', className = '' }: TokenIconProps) {
  const [imageLoaded, setImageLoaded] = useState(false);
  const [imageError, setImageError] = useState(false);
  const logoUrl = getTokenLogoUrl(symbol);
  const hasLogo = !!logoUrl;

  // Reset states when symbol changes
  useEffect(() => {
    setImageLoaded(false);
    setImageError(false);
  }, [symbol, logoUrl]);

  return (
    <div
      className={`${size} ${className} rounded-full flex items-center justify-center font-bold text-xs overflow-hidden transition-all duration-200`}
      style={{
        background: (!hasLogo || !imageLoaded || imageError) ? getTokenColor(symbol) : '#FFFFFF',
        padding: (hasLogo && imageLoaded && !imageError) ? '6px' : '0',
      }}
    >
      {hasLogo && !imageError ? (
        <img
          src={logoUrl}
          alt={symbol}
          className={`w-full h-full object-contain transition-opacity duration-200 ${imageLoaded ? 'opacity-100' : 'opacity-0'}`}
          onLoad={() => setImageLoaded(true)}
          onError={() => setImageError(true)}
        />
      ) : null}
      {(!hasLogo || !imageLoaded || imageError) && (
        <span className="text-white">{symbol.slice(0, 1)}</span>
      )}
    </div>
  );
}
